import { EnvModel } from '../env/model';
import Prismic from 'prismic-javascript';
import { action } from 'mobx';

export class PrismicController {

  constructor(
    private env: EnvModel
  ) {}

  private getApi = async () => Prismic.getApi(this.env.prismicEndpoint);
  private getLandingApi = async () => Prismic.getApi(this.env.prismicLandingEndpoint);

  @action
  getSingle = async (key: string): Promise<{ data: any }> => {
    const api = await this.getApi();
    return api.getSingle(key);
  };

  @action
  query = async (predicate: any, options?: any): Promise<{ results: any }> => {
    const api = await this.getApi();
    return api.query(predicate, options);
  };

  @action
  queryLanding = async (predicate: any, options?: any): Promise<{ results: any }> => {
    const api = await this.getLandingApi();
    return api.query(predicate, options);
  };

}